import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { SharedObject } from '../../sharedObject';

@Component({
  selector: 'sheed-footer',
  templateUrl: './sheed-footer.component.html',
  styleUrls: ['./sheed-footer.component.scss']
})
export class SheedFooterComponent implements OnInit {

  constructor(private commonService: CommonService) { }

  ngOnInit() {
  }
  samandehiClick() {
    window.open(this.commonService.sanitize('https://logo.samandehi.ir/Verify.aspx?id=127059&p=rfthuiwkjyoeobpddshwpfvl').toString(), "Popup", "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30")
  }
  nezaatClick() {
    window.open("https://trustseal.enamad.ir/Verify.aspx?id=98040&amp;p=Hgjc0etrSsRq4wKG&quot;, &quot;Popup&quot;,&quot;toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30&quot");
  }
}
